import { CommonModule, I18nPluralPipe, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Bildungsangebot } from '../../model';
import { ScrollToAndFocusDirective } from '../../shared/directives';
import { ANBIETER_LOGO_FALLBACK } from '../../shared/utils/anbieter-logo-fallback';
import { getLabelFromWeiterbildungsart } from '../../model/weiterbildungsarten';
import { breakTitle } from '../../shared/utils/break-title';

@Component({
  selector: 'now-wbsuche-lib-angebot-list-item',
  imports: [CommonModule, ScrollToAndFocusDirective, I18nPluralPipe, NgOptimizedImage, RouterLink],
  templateUrl: './angebot-list-item.component.html',
  styleUrl: './angebot-list-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AngebotListItemComponent {
  @Input({ required: true }) angebot!: Bildungsangebot;

  @Input({ required: true }) selected = false;

  public anzahlTerminePlural = { '=1': '1 Termin', other: '# Termine' };

  public breakTitle = breakTitle;

  public hasImgError = false;

  get anbieterLogo(): string {
    return this.hasImgError
      ? ANBIETER_LOGO_FALLBACK
      : this.angebot.bildungsanbieter?.logo || ANBIETER_LOGO_FALLBACK;
  }

  get weiterbildungsart(): string {
    return getLabelFromWeiterbildungsart(this.angebot.weiterbildungsart);
  }
}
